
const SET_CORE_CONCEPTS = 'browseFilters/SET_CORE_CONCEPTS';
const SET_DOMAINS = 'browseFilters/SET_DOMAINS';
const SET_UNITS = 'browseFilters/SET_UNITS';
const SET_SUBJECTS = 'browserFilters/SET_SUBJECTS';
const SET_GRADES = 'browserFilters/SET_GRADES';
const SET_SUBJECT_GRADES = 'browserFilters/SET_SUBJECT_GRADES';

export default {
  SET_CORE_CONCEPTS,
  SET_DOMAINS,
  SET_UNITS,
  SET_SUBJECTS,
  SET_GRADES,
  SET_SUBJECT_GRADES,
};
